const CNdata = {
  "editor.alreadyEntered": "已输入{count}/140字",
  "editor.placeholder": "说点什么吧...",
  "editor.maxLength": "字数上限{maxLength}",
  "editor.SubmitBtn": "发送",
  "editor.uploadTip": "上传图片",
  "editor.uploadCount": "(您还能上传{count}张图片)",
  "editor.uploadBtn": "上传",

  "comment.tourist": "游客",
  "comment.totalComment": "共{total}条评论",
  "comment.reply": "回复",
  "comment.moreComment": "更多评论",

  "reply.totalReply": "共{total}条回复",
  "reply.moreReply": "更多回复",
  "reply.collapse": "收起回复",

  "picture.collapse": "收起",
  "picture.viewOriginal": "查看原图",

  "popConfirm.title": "确定要删除吗",
  "popConfirm.ok": "确定",
  "popConfirm.cancel": "取消",
  "popConfirm.delete": "删除",

  "message.noMoreComment": "没有更多评论了",
  "message.noMoreData": "没有更多数据了！",
  "message.notNull": "没写内容呢",
  "message.success": "评论已发送！",
  "message.replyNoNull": "没写内容呢",
  "message.replySuccess": "回复已发送！",
  "message.cancelLickSuccess": "已取消点赞！",
  "message.likeSuccess": "已赞！"
};

export default CNdata;



// WEBPACK FOOTER //
// ./src/lang/zh-CN.js